import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'src/app/air/modules/common/service/dialog/dialog.service';
import { SubSink } from "subsink";

@Component({
    selector: 'bdp-air-common-dialog',
    templateUrl: './air-common-dialog.component.html',
    styleUrls: ['./air-common-dialog.component.scss'],
    standalone: false
})
export class AirCommonDialogComponent implements OnInit, OnDestroy {
  dialogData: any = {};
  toasterData: any = {};
  private subscription = new SubSink();

  constructor(
    private dialogService: DialogService,
    private messageService: MessageService) { }

  ngOnInit(): void {
    this.dialogData = this.dialogService.getConfirmData(false);
    this.toasterData = this.dialogService.getToasterData(false);
    this.subscription.add(
      this.dialogService.$dialogData.subscribe((dialogData: any) => {
        if (dialogData) {
          this.dialogData = dialogData;
        }
      }),
      this.dialogService.$toasterData.subscribe((toasterData: any) => {
        if (toasterData) {
          this.toasterData = toasterData;
          if (this.toasterData.hasUndo) {
            this.messageService.add({
              key: 'bdpToasterUndo',
              severity: toasterData.severity,
              detail: toasterData.content,
              life: 10000
            });
          } else {
            this.messageService.add({
              key: 'bdpToaster',
              severity: toasterData.severity,
              detail: toasterData.content,
              life: 10000
            });
          }
        }
      })
    )
  
    this.subscription.add(
      this.dialogService.$dialogData.subscribe((dialogData: any) => {
          if (dialogData) {
              this.dialogData = JSON.parse(dialogData); // Parse the dialog data
        //      console.log('Parsed Dialog Data:', this.dialogData); // Debugging: Log the parsed dialog data
          }
      })
  );
 
  }


  accept() {
    if (this.dialogData.buttons.accept && this.dialogData.buttons.accept.action) {
     //   console.log('Executing accept action'); // Debugging: Log when the accept action is executed
        this.dialogData.buttons.accept.action(); // Call the onAccept callback
    } else {
        console.error('Accept action is not defined'); // Debugging: Log if the action is missing
    }
    this.dialogData.isOpen = false; // Close the dialog
}
  reject() {
    if (this.dialogData.buttons.reject && this.dialogData.buttons.reject.action) {
      this.dialogData.buttons.reject.action();
    }
    this.dialogData.isOpen = false;
  }

  undo() {
    if (this.toasterData.undo && this.toasterData.undo.action) {
      this.toasterData.undo.action();
    }
    this.messageService.clear();
  }

  closePopup() {
    if (this.toasterData.close) {
      this.toasterData.close();
    }
    this.messageService.clear();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
